<template lang="pug">
  include ../mixins
  +b.g-row.--appearance_spaced.--space_xs
    +b.g-cell(
      v-for="socialName in socials"
      :key="socialName"
    )
      share-network(
        :url="shareUrl"
        :title="shareTitle"
        :network="socialName"
      )
        +b.action-item
          +b.I.ls-icon(:class="`ls-icon--type_${socialName}`")
</template>
<script>
import Vue from 'vue'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing)

export default {
  props: {
    shareUrl: String,
    shareTitle: String,
  },

  data() {
    return {
      socials: [
        'facebook',
        'twitter',
        'viber',
        'whatsapp',
        'telegram',
      ],
    }
  },
}
</script>
